import React, { useEffect } from 'react';

function Register() {
	useEffect(() => {
		const script = document.createElement('script');
		script.src = 'https://study-bucket-campus.s3.eu-central-1.amazonaws.com/js/widget.js';
		document.head.appendChild(script);

		return () => {
			document.head.removeChild(script);
		};
	}, []);

	return <div id="registration-widget" data-type="page" />;
}

export default Register;
